import { Link, useLocation } from "react-router-dom";
import { Menu, X, Mail, Phone, MapPin } from "lucide-react";
import { useState } from "react";
import Chatbot from "@/components/Chatbot";

export default function Layout({ children }) {
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (p) => loc.pathname === p;

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <header className="sticky top-0 z-40 bg-bg-dark border-b border-line-dark">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
            <img
              src="https://customer-assets.emergentagent.com/job_iper-ammortamento/artifacts/jputfjcg_Studio-ingegneria-logb%20%282%29%20%281%29.png"
              alt="Studio Ingegneria Valore"
              className="h-12 md:h-14 w-auto object-contain"
            />
            <span className="hidden sm:inline-block font-display text-[10px] tracking-[0.25em] text-brand uppercase border-l border-white/20 pl-3">
              Iperammortamento<br />2026
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              data-testid="nav-home"
              className={`text-sm font-display tracking-widest uppercase text-white/80 hover:text-white underline-anim ${isActive("/") ? "active text-white" : ""}`}
            >
              Home
            </Link>
            <Link
              to="/calcolatore"
              data-testid="nav-calc"
              className={`text-sm font-display tracking-widest uppercase text-white/80 hover:text-white underline-anim ${isActive("/calcolatore") ? "active text-white" : ""}`}
            >
              Calcolatore
            </Link>
            <Link
              to="/storico"
              data-testid="nav-history"
              className={`text-sm font-display tracking-widest uppercase text-white/80 hover:text-white underline-anim ${isActive("/storico") ? "active text-white" : ""}`}
            >
              Storico
            </Link>
            <Link
              to="/contattaci"
              data-testid="nav-contact"
              className="text-sm font-display tracking-widest uppercase text-white/80 hover:text-white underline-anim"
            >
              Contattaci
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/calcolatore"
              data-testid="header-cta"
              className="inline-flex items-center gap-2 px-5 h-11 bg-brand text-white font-display tracking-wider text-sm uppercase rounded hover:bg-brand-dark hover:shadow-brand-glow"
            >
              Simula
            </Link>
          </div>

          <button className="md:hidden p-2 text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-line-dark bg-bg-dark px-6 py-4 flex flex-col gap-3">
            <Link to="/" onClick={() => setOpen(false)} className="py-2 text-sm text-white/80 font-display uppercase tracking-wider">Home</Link>
            <Link to="/calcolatore" onClick={() => setOpen(false)} className="py-2 text-sm text-white/80 font-display uppercase tracking-wider">Calcolatore</Link>
            <Link to="/storico" onClick={() => setOpen(false)} className="py-2 text-sm text-white/80 font-display uppercase tracking-wider">Storico</Link>
            <Link to="/contattaci" onClick={() => setOpen(false)} className="py-2 text-sm text-white/80 font-display uppercase tracking-wider">Contattaci</Link>
          </div>
        )}
      </header>

      <main className="flex-1">{children}</main>
      <Chatbot />

      <footer className="bg-bg-dark text-white/70 mt-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_iper-ammortamento/artifacts/jputfjcg_Studio-ingegneria-logb%20%282%29%20%281%29.png"
              alt="Studio Ingegneria Valore"
              className="h-16 w-auto object-contain"
            />
            <p className="mt-4 max-w-md text-sm text-white/60 leading-relaxed">
              Progettazione energetica integrata. Perizie Industria 5.0, analisi termotecnica,
              risparmio energetico e sostenibilità ambientale.
            </p>
          </div>
          <div>
            <div className="font-display text-brand text-xs tracking-[0.25em] uppercase">Contatti</div>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand" /> Via Ca' Brusà, 16<br />Lavagno (VR)</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand" /><a href="mailto:info@studioingegneriavalore.it" className="hover:text-white">info@studioingegneriavalore.it</a></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand" />045 5116212</li>
            </ul>
          </div>
          <div>
            <div className="font-display text-brand text-xs tracking-[0.25em] uppercase">Link</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="https://www.studioingegneriavalore.it/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Sito ufficiale</a></li>
              <li><a href="https://www.studioingegneriavalore.it/servizi/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Servizi</a></li>
              <li><a href="https://www.studioingegneriavalore.it/impresa/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Impresa</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-line-dark">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-white/40">
            <div>© {new Date().getFullYear()} Studio Ingegneria Valore. Le stime sono indicative e devono essere validate da un consulente qualificato.</div>
            <div className="font-mono">L. 30/12/2025 n. 199 · Iperammortamento 2026</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
